<template>
  <div class="ele-state-wrap" v-loading="loading">
    <div class="box-title dn-title-bg titleZt">{{name}}</div>
    <div class="content dn-content-bg" v-if="!loading">
      <div class="item">
        <div class="chart">
          <semicircle-chart :value="obj[type+'_'+keys.first]==''?'-':obj[type+'_'+keys.first]" :rated="220" :title="title.first" :unit="unit" :minMaxValues="minMaxValues" :name="title.first"></semicircle-chart>
        </div>
      </div>
      <div class="item">
        <div class="chart">
          <semicircle-chart :value="obj[type+'_'+keys.second]==''?'-':obj[type+'_'+keys.second]" :rated="220" :title="title.second" :unit="unit" :minMaxValues="minMaxValues" :name="title.second"></semicircle-chart>
        </div>
      </div>
      <div class="item">
        <div class="chart">
          <semicircle-chart :value="obj[type+'_'+keys.third]==''?'-':obj[type+'_'+keys.third]" :rated="220" :title="title.third" :unit="unit" :minMaxValues="minMaxValues" :name="title.third"></semicircle-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SemicircleChart from "./SemicircleChart.vue";
export default {
  components: { SemicircleChart },
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      }
    },
    minMaxValues: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String || Number,
      default: ""
    },
    isHigh: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: true,
      unit:'',
      keys: {
        first: "a",
        second: "b",
        third: "c"
      },
      title: {
        first: "",
        second: "",
        third: ""
      }
    };
  },
  watch: {
    obj:{
      handler(val, oldValue){
        if (Object.keys(val).length > 0) {
          let typeTitle = "";
          switch (this.type) {
            case "voltage":
              this.unit = "V";
              typeTitle = "电压";
              break;
            case "current":
              this.unit = "A";
              typeTitle = "电流";
              break;
          }
          if (this.isHigh) {
            this.keys = {
              first: "ca",
              second: "ab",
              third: "bc"
            };

            this.title = {
              first: "CA线" + typeTitle,
              second: "AB线" + typeTitle,
              third: "BC线" + typeTitle
            };
          } else {
            this.keys = {
              first: "a",
              second: "b",
              third: "c"
            };

            this.title = {
              first: "A相" + typeTitle,
              second: "B相" + typeTitle,
              third: "C相" + typeTitle
            };
          }
          this.loading = false;
        }
      },
      deep:true,
      immediate:true
    }
  }
};
</script>

<style lang="scss" scoped>
.ele-state-wrap{
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.content {
  display: flex;
  flex:1;
}
.item {
  flex: 1;
  display: flex;
  flex-flow: column;
  padding: 5px;
  text-align: center;
  min-height: 110px;
  box-sizing: border-box;
  justify-content: space-around;
}
.big-text {
  font-size: 22px;
}
.chart {
    width: 90%;
    margin: 0px auto;
    height: 210px;
}
</style>